import { create } from '@dojo/framework/core/vdom';
import { i18n } from '@dojo/framework/core/middleware/i18n';
import { lccstate } from './base';
const factory = create({ lccstate, i18n });
export const createNlsMiddleware = (namespace) => {
    const nlsMiddleware = factory(({ middleware: { lccstate, i18n } }) => {
        return () => {
            const { get, path } = lccstate;
            const dynls = get(path('dynls'));
            const bundle = dynls && dynls.get(namespace);
            if (!bundle) {
                return { isPlaceholder: true, format: () => '', messages: {} };
            }
            return i18n.localize(bundle);
        };
    });
    return nlsMiddleware;
};
